// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__Rqh8r","modalFooterButton":"ModalNotes_modalFooterButton__3phMN"};